/* QBand · Carregador único do GSAP + ScrollTrigger.
   Várias seções podem incluir este arquivo; ele carrega o GSAP uma vez só e
   expõe window.qbMotion (Promise que resolve com gsap pronto).
   Uso nas seções: window.qbMotion?.then((gsap) => { ... })

   Correção importante: o Horizon usa `scroll-behavior: smooth` no <html>.
   O ScrollTrigger rola a página até o topo para medir as seções; com rolagem
   suave essa ida não é instantânea e as medidas saem erradas (animações pulam
   e a tela parece travar). Desligamos a rolagem suave só durante a medição. */
(() => {
  if (window.qbMotion) return;
  const me = document.currentScript;

  const load = (src) =>
    new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });

  window.qbMotion = (async () => {
    if (!window.gsap) await load(me.dataset.gsap);
    if (!window.ScrollTrigger) await load(me.dataset.scrolltrigger);
    const { gsap, ScrollTrigger } = window;
    gsap.registerPlugin(ScrollTrigger);

    // A barra de endereço do Safari aparece/some na rolagem; não recalcular por isso
    ScrollTrigger.config({ ignoreMobileResize: true });

    const html = document.documentElement;
    ScrollTrigger.addEventListener('refreshInit', () => {
      html.style.scrollBehavior = 'auto';
    });
    ScrollTrigger.addEventListener('refresh', () => {
      html.style.scrollBehavior = '';
    });

    // Imagens e fontes mudam a altura da página depois do carregamento
    if (document.readyState !== 'complete') {
      window.addEventListener('load', () => ScrollTrigger.refresh(), { once: true });
    }
    document.fonts?.ready.then(() => ScrollTrigger.refresh());

    return gsap;
  })();
})();
